import React from 'react'
import terms from "HELPDESK/CommonResources/images/terms.svg"
import policy from "HELPDESK/CommonResources/images/privacy.svg"
 
const TermsPolicies = () => {
  return (
    <div className='subContainers workspace-current-modal-mode' style={{ padding: "14px 14px 20px" }}>
      <p style={{ fontSize: "14px", fontWeight: "bold" }}>Terms and Policies</p>
    
      <div className='mt-2 pl-2 ws-app-theme-color-20' style={{display:"flex",alignItems:"baseline",gap:"2px",borderRadius:"3px",border:"1px solid #dddddd"}}>
      <div style={{ width: "20px" }}>
          <img src={terms} style={{ width: "100%" }} />
        </div>
        <a style={{fontSize:"13px",color:'inherit',padding:"5px"}} href="https://vmedulife.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms and Condition</a> 
      </div>

      <div className='mt-2 pl-2 ws-app-theme-color-20' style={{display:"flex",alignItems:"baseline",gap:"2px",borderRadius:"3px",border:"1px solid #dddddd"}}>
      <div style={{ width: "20px" }}>
          <img src={policy} style={{ width: "100%" }} />
        </div>
        <a style={{fontSize:"13px",padding:"5px",color:'inherit'}} href="https://vmedulife.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policies</a> 
      </div>

    </div>
  )
}

export default TermsPolicies